import { get } from 'lodash';

export const getPageId = () => get(window, 'ZD.configs.PAGE_ID');
